/* ABC: страница товара.
   1) Артикул («Article: 00-509») — навёл/нажал → копируется, подпись COPIED.
   2) Состав и уход: слова перед двоеточием (Shell:, Lining:, Washing:…)
      полужирным, как на abcclothes.world. */
(function () {
  function article(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      var m = n.nodeValue.match(/(Article:\s*)([A-Za-z0-9-]+)/);
      if (!m || (n.parentElement && n.parentElement.closest('.abc-article'))) continue;
      var span = document.createElement('button');
      span.type = 'button';
      span.className = 'abc-article';
      span.title = 'Copy article';
      span.textContent = m[2];
      var after = n.splitText(n.nodeValue.indexOf(m[0]) + m[1].length);
      after.nodeValue = after.nodeValue.slice(m[2].length);
      after.parentNode.insertBefore(span, after);
      break;
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.abc-article');
    if (!b) return;
    e.preventDefault();
    var code = b.dataset.code || b.textContent;
    b.dataset.code = code;
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(function () {
      var r = document.createRange(); r.selectNodeContents(b); var s = getSelection(); s.removeAllRanges(); s.addRange(r); document.execCommand('copy'); s.removeAllRanges();
    }).finally(function () {
      b.classList.add('is-copied');
      setTimeout(function () { b.classList.remove('is-copied'); }, 1500);
    });
  });
  function boldLabels(el) {
    if (el.dataset.abcBold) return;
    el.dataset.abcBold = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      if (t.parentElement.closest('b,strong')) return;
      var html = t.nodeValue.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; })
        .replace(/(^|[.;]\s+|^\s*)([A-Z][A-Za-z ]{1,28}:)/g, '$1<b>$2</b>');
      if (html === t.nodeValue) return;
      var span = document.createElement('span');
      span.innerHTML = html;
      t.replaceWith(span);
    });
  }
  function scan() {
    document.querySelectorAll('.product-details details').forEach(function (d) {
      var title = (d.querySelector('summary') || {}).textContent || '';
      var body = d.querySelector('.details-content, .details__content') || d;
      if (/description/i.test(title)) article(body);
      if (/composition|materials|care/i.test(title)) boldLabels(body);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
})();
